import React, { useState, useEffect } from "react";


import validator from "validator";


import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";

import {
    ButtonComponent, InputComponent
} from "@Components/Forms";


import UserDashboardUserMenuComponent from "@Pages/@@UserPages/@@Dashboard/@@@Menu";


import userWalletHeaderImage from "./@Images/wallet-header-image.svg";

import IconPlusSmBrown from "./@Icons/icon-plus-sm-brown.svg";
import IconLockXsGrey from "./@Icons/icon-lock-xs-grey.svg";

import IconCreditCardSmGrey from "./@Icons/icon-credit_card-sm-grey.svg";
import IconBankAccountSmGrey from "./@Icons/icon-bank-sm-grey.svg";

import IconDropdownDownSmGrey from "./@Icons/icon-dropdown_down-sm-grey.svg";
import IconDropdownDownSmDarkGrey from "./@Icons/icon-dropdown_down-sm-grey.svg";
import IconDropdownUpSmDarkGrey from "./@Icons/icon-dropdown_up-sm-dark_grey.svg";


import "./index.scss";

import {
    DefaultPopupComponent, DropdownFieldComponent, DropdownFieldOptionInterface
} from "@Elements";
import UserDashboardWalletAddNewAccountComponent from "@Pages/@@UserPages/@@Dashboard/@Wallet/AddNewAccount";


interface UserRegisteredWithdrawOptionInterface {
    withdrawOptionType: 'bankAccount' | 'creditCard';
    withdrawOptionAccountOrCardNumber: 'string';
    withdrawOptionUserFirstName: 'string';
    withdrawOptionUserLastName: 'string';
    withdrawOptionLabel?: 'string';
}


export const UserDashboardWalletPageComponent:React.FC = () => {


    const [
        userRegisteredCardsAndBankAccounts, setUserRegisteredCardsAndBankAccounts
    ] = useState<UserRegisteredWithdrawOptionInterface[] | null>(null);

    useEffect(() => {
        return () => {
            setUserRegisteredCardsAndBankAccounts(null);
        };
    }, []);


    const [
        addNewWithdrawAccountPopupActiveStatus, setAddNewWithdrawAccountPopupActiveStatus
    ] = useState(false);

    useEffect(() => {
        return () => {
            setAddNewWithdrawAccountPopupActiveStatus(false);
        };
    }, []);


    const addNewWithdrawAccountRequestSubmitHandler = () => {

    };









    return (
        <>

            <UserDashboardUserMenuComponent />

            <Col xs={12} lg={9} className={`user-dashboard-content-container`}>
                <Row className={`user-dashboard-content-container__container-content`}>

                    <Col xs={12} className={`user-dashboard-content-header`}>
                        <Row className={`user-dashboard-content-header__header-content`}>
                            <Col xs={'auto'} className={`user-dashboard-content-header__header-content__header-title`}>
                                <span>Wallet</span>
                            </Col>
                        </Row>
                    </Col>

                    <Col xs={12} className={`user-dashboard-content-section user-dashboard-wallet-section`}>
                        <Row className={`user-dashboard-content-section__section-container user-dashboard-wallet-section__section-container`}>

                            <Col xs={6} lg={2} className={'user-dashboard-wallet-section__wallet-image'}>
                                <SvgIconComponent iconSource={userWalletHeaderImage} className={'user-dashboard-wallet-section__wallet-image__image-element'} />
                            </Col>

                            <Col xs={6} lg={3} className={'user-dashboard-wallet-section__wallet-funds-value'}>
                                <span className={'user-dashboard-wallet-section__wallet-funds-value__funds-header'}>Your funds</span>
                                <span className={'user-dashboard-wallet-section__wallet-funds-value__funds-value'}>$0.00</span>
                            </Col>

                            {!userRegisteredCardsAndBankAccounts?.length &&
                            <Col xs={12} lg={{ span: 5, offset: 2 }} className={'user-dashboard-wallet-section__wallet-add-withdraw-method'}>
                                <ButtonComponent
                                    size={'l'}
                                    text={'Add account to withdraw funds'} iconLeft={IconPlusSmBrown}
                                    callback={() => setAddNewWithdrawAccountPopupActiveStatus(true)}
                                />
                            </Col>
                            }

                        </Row>
                    </Col>

                    {addNewWithdrawAccountPopupActiveStatus &&
                    <UserDashboardWalletAddNewAccountComponent
                        popupCloseCallback={() => setAddNewWithdrawAccountPopupActiveStatus(false)}
                    />
                    }

                </Row>
            </Col>

        </>
    );

};


export default UserDashboardWalletPageComponent;
